import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ApplicationLoadingState } from '@/components/application/layout/ApplicationLoadingState';

interface ProtectedRouteWithProfileCheckProps {
  children: React.ReactNode;
}

export const ProtectedRouteWithProfileCheck: React.FC<ProtectedRouteWithProfileCheckProps> = ({ 
  children 
}) => {
  const { isAuthenticated, isLoading, user, session } = useAuth();

  // Show loading for initial authentication check
  if (isLoading) {
    console.log('ProtectedRoute: Loading auth state');
    return <ApplicationLoadingState />;
  }

  // If we have a session but no user yet (OAuth callback processing), keep loading
  if (session && !user) {
    console.log('ProtectedRoute: Session exists but user not loaded, continuing to load');
    return <ApplicationLoadingState />;
  }

  // Only redirect to login if we're certain there's no authentication
  if (!isAuthenticated && !session) {
    console.log('ProtectedRoute: Not authenticated, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  // Block unverified users from accessing protected content
  // Check both user.emailVerified from database and session email_confirmed_at
  // But prioritize the database status (user.emailVerified)
  if (user && user.emailVerified === false) {
    console.log('ProtectedRoute: Email not verified (database check), redirecting to verification page');
    return <Navigate to="/verify-email" replace />;
  }

  console.log('ProtectedRoute: Rendering protected content');
  return <>{children}</>;
};